import { render, staticRenderFns } from "./SettingsInvoiceMessages.vue?vue&type=template&id=3448c634"
import script from "./SettingsInvoiceMessages.vue?vue&type=script&lang=js"
export * from "./SettingsInvoiceMessages.vue?vue&type=script&lang=js"
import style0 from "./SettingsInvoiceMessages.vue?vue&type=style&index=0&id=3448c634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports